import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const CheckIns: React.FC<PropsType> = ({ size = 60, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
    >
      <path
        d="M44.2857 44.209C46.6369 45.2534 48.1347 46.5331 48.5972 47.8927C49.0597 49.2524 48.467 50.6335 46.8912 51.8684C45.3153 53.1032 42.8239 54.1388 39.7196 54.8494C36.6152 55.56 33.0314 55.9151 29.403 55.8714C25.7747 55.8278 22.2579 55.3873 19.2796 54.6036C16.3013 53.8198 13.9896 52.7265 12.6251 51.4562C11.2605 50.1859 10.9018 48.7934 11.5925 47.4476C12.2833 46.1019 13.9937 44.8608 16.5162 43.875"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30 7.5C38.7297 7.5 45.75 14.4145 45.75 22.875C45.75 27.8443 43.113 32.8983 38.3994 37.9062L37.9375 38.3906C36.4467 39.93 34.8631 41.3531 33.2646 42.6396L32.5781 43.1826C32.2577 43.4322 31.9494 43.6675 31.6543 43.8867L30.8115 44.4971L30.1377 44.96C30.0767 44.9997 29.9983 45.01 29.9287 44.9902L29.8623 44.96L29.1885 44.4971C28.9225 44.3092 28.6407 44.1059 28.3457 43.8867L27.4219 43.1826C25.8207 41.9353 24.2228 40.5488 22.707 39.043L22.0625 38.3906C17.0595 33.2244 14.25 28.0045 14.25 22.875L14.2549 22.4795C14.4696 14.2001 21.4067 7.5 30 7.5Z"
        fill="#FFD440"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.5449 23.5938L27.2322 28.2143L37.5 17.9465"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M39.1371 47.0878C39.6966 47.5776 39.8769 48.1048 39.662 48.6228C39.4472 49.1407 38.8437 49.6334 37.9052 50.0571C36.9667 50.4809 35.722 50.8227 34.2815 51.0522C32.841 51.2817 31.249 51.3919 29.6467 51.3729C28.0443 51.354 26.481 51.2065 25.0953 50.9436C23.7095 50.6807 22.5441 50.3104 21.7022 49.8656C20.8603 49.4208 20.3679 48.9152 20.2687 48.3935C20.1695 47.8719 20.4664 47.3503 21.1333 46.875"
        stroke="#003125"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CheckIns;
